import { createRouter, createWebHistory } from "vue-router";
import { routes as acfssParametrosRoutes } from "@/router/mod/AcfssParametros";
import { routes as acfssProcesosRoutes }   from "@/router/mod/AcfssProcesos";
import { routes as acfssReportesRoutes }   from "@/router/mod/AcfssReportes";
import { routes as adminParametrosRoutes } from "@/router/mod/AdminParametros";
import { routes as adminProcesosRoutes }   from "@/router/mod/AdminProcesos";
import { routes as adminReportesRoutes }   from "@/router/mod/AdminReportes";
import authRoutes          from "./authRoutes";
import formsRoutes         from "./formsRoutes";
import linksRoutes         from "./linksRoutes";
import masterDetailsRoutes from "./masterDetailsRoutes";
import reportsRoutes       from "./reportsRoutes";
import simpleFormsRoutes   from "./simpleFormsRoutes";
import utilsRoutes         from "./utilsRoutes";
import helpRoutes          from "./helpRoutes";
import sandboxRoutes       from "./sandboxRoutes";

// ── Vistas generales con lazy loading ─────────────────────────
const generalRoutes = [
  { path: "/",                  name: "Home",             component: () => import("@/views/Home.vue")                      },
  { path: "/MenuPrincipal",     name: "MenuPrincipal",    component: () => import("@/views/MenuPrincipal.vue")             },
  { path: "/seleccion-empresa", name: "SeleccionEmpresa", component: () => import("@/components/SeleccionEmpresa.vue")     },
  { path: "/acerca-de",         name: "AcercaDe",         component: () => import("@/views/AcercaDe.vue")                  },
];

const routes = [
  ...adminParametrosRoutes,
  ...adminProcesosRoutes,
  ...adminReportesRoutes,
  ...acfssParametrosRoutes,
  ...acfssProcesosRoutes,
  ...acfssReportesRoutes,
  ...authRoutes,
  ...formsRoutes,
  ...linksRoutes,
  ...masterDetailsRoutes,
  ...reportsRoutes,
  ...simpleFormsRoutes,
  ...utilsRoutes,
  ...helpRoutes,
  ...sandboxRoutes,
  ...generalRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;